import useWebChatUIContext from '/druid/useWebChatUIContext';

function useInternalMarkdownIt() {
  return useWebChatUIContext().internalMarkdownItState;
}

export default useInternalMarkdownIt;
